var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择公众号" },
                        model: {
                          value: _vm.q.wxAccountAppid,
                          callback: function ($$v) {
                            _vm.$set(_vm.q, "wxAccountAppid", $$v)
                          },
                          expression: "q.wxAccountAppid",
                        },
                      },
                      _vm._l(_vm.wxAccountList, function (item) {
                        return _c("el-option", {
                          key: item.appid,
                          attrs: { label: item.name, value: item.appid },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 4 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入昵称" },
                      model: {
                        value: _vm.q.nickname,
                        callback: function ($$v) {
                          _vm.$set(_vm.q, "nickname", $$v)
                        },
                        expression: "q.nickname",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", icon: "el-icon-search" },
                        on: { click: _vm.search },
                      },
                      [_vm._v("搜索")]
                    ),
                    _vm.permissions.mp_wxaccountfans_sync
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", icon: "el-icon-sort" },
                            on: { click: _vm.asyncFans },
                          },
                          [_vm._v("\n            同步\n          ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              permission: _vm.permissionList,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOption,
              "before-open": _vm.handleOpenBefore,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "refresh-change": _vm.refreshChange,
              "row-update": _vm.handleUpdate,
              "row-save": _vm.handleSave,
              "row-del": _vm.rowDel,
            },
            scopedSlots: _vm._u([
              {
                key: "tagIds",
                fn: function (scope) {
                  return _vm._l(scope.row.tagList, function (tag, index) {
                    return _c(
                      "span",
                      { key: index },
                      [
                        _c("el-tag", [_vm._v(_vm._s(tag.tag) + " ")]),
                        _vm._v("  \n        "),
                      ],
                      1
                    )
                  })
                },
              },
              {
                key: "tagIdsForm",
                fn: function (scope) {
                  return [
                    _c("avue-select", {
                      attrs: {
                        dic:
                          _vm.tagOption === []
                            ? scope.row.tagList
                            : _vm.tagOption,
                        props: _vm.tagProps,
                        multiple: "",
                        placeholder: "请选择标签",
                      },
                      model: {
                        value: _vm.form.tagIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "tagIds", $$v)
                        },
                        expression: "form.tagIds",
                      },
                    }),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.form,
              callback: function ($$v) {
                _vm.form = $$v
              },
              expression: "form",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }